import { render, staticRenderFns } from "./NewFeedInfo.vue?vue&type=template&id=962cd2a0"
import script from "./NewFeedInfo.vue?vue&type=script&lang=js"
export * from "./NewFeedInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports